<script setup>
import { resourceV2 } from '@/composables/resource';
import { onBeforeMount } from 'vue';
import { useRoute } from 'vue-router';
import ListingForm from '@/components/Secondary/Marketplace/ListingForm.vue';

const route = useRoute();
const listing = resourceV2({
    url: `/api/marketplace/listings/${route.params.id}`
});

onBeforeMount(() => listing.fetch());
</script>

<template>
    <layout-main>
        <layout-content>
            <content-header>
                <top-nav>
                    <top-nav-back />
                    <top-nav-title>Edit Listing</top-nav-title>
                </top-nav>
            </content-header>

            <content-body>
                <div v-if="listing.loadState === 'ready'" class="px-4 py-6">
                    <div v-if="listing.data.status !== 'draft'" class="text-sm px-2 py-2 mb-3 rounded-md bg-warning/20 text-warning">
                        <template v-if="listing.data.status === 'pending'">
                            This listing is currently being reviewed and cannot be edited
                        </template>
                        <template v-else>
                            Editing this listing will set it back to draft and will need to be reviewed again before it can go live
                        </template>
                    </div>
                    <ListingForm :disabled="listing.data.status === 'pending'" :listing="listing.data" />
                </div>
                <app-layout-skeleton v-else-if="listing.loadState === 'loading'" />
            </content-body>
        </layout-content>
    </layout-main>
</template>
